import { render, staticRenderFns } from "./registrationComponent.vue?vue&type=template&id=026c89aa&scoped=true"
import script from "./registrationComponent.vue?vue&type=script&lang=js"
export * from "./registrationComponent.vue?vue&type=script&lang=js"
import style0 from "./registrationComponent.vue?vue&type=style&index=0&id=026c89aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026c89aa",
  null
  
)

export default component.exports